<template>
    <div>
        <span>{{ commentText }}</span>
    </div>
</template>

<script>
export default {
    name: "CommentBody",
    props: ['commentText'],
}
</script>

<style lang="css" scoped>
    span {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        word-break: break-all;
        white-space: pre-line;
    }
</style>
